@let matter = matter$ | async | foldSuccess;
@if (matter && matter.status === 'public') {
	@switch (matter.type) {
		@case ('remote-content') {
			<iframe
				#iframe
				[srcdoc]="matter.content.html! | unescapeHtml | trustedHtml"
				[attr.title]="matter.key"
			></iframe>
		}
	}
}
